import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import fetch from '../../../utils/fetch';

import styles from './index.module.scss';

const debug = require('debug')('cw:orderEmailContent');

const OrderEmailContent = ({ router }) => {
  const [email, setEmail] = useState(null);
  // Fetch orderId from the URL.
  // Expected URL format is something like this:
  // /donate/single/checkout/thank-you?type=single&orderID=93195.
  // eslint-disable-next-line react/prop-types
  const orderId = (router.query && router.query.orderID) || null;
  if (!orderId) {
    return null;
  }

  // Click handler on CTA to load email content.
  const loadOrderEmailContent = async (event) => {
    // Avoid jumping of the page when clicking on a link.
    event.preventDefault();

    try {
      const response = await fetch(`/cw_mail/order/${orderId}`);
      // Response body should have this format:
      // { subject: 'Email subject', body: '<div>Email content</div>' }.
      setEmail(response.body);
    } catch (error) {
      debug('Error during fetching order email content: %O', error);
    }
  };

  return (
    <div className={styles['order-email-content']}>
      <div className="container">
        {!email && (
          <a href="#" onClick={loadOrderEmailContent} className="load-email-content">
            Load email content sent for this order [visible only on dev environments]
          </a>
        )}
        {email && (
          <>
            <h3 className={`${styles['order-email-subject']} order-email-subject`}>
              {email.subject}
            </h3>
            <div className={`${styles['order-email-body']} order-email-body`}>{email.body}</div>
          </>
        )}
      </div>
    </div>
  );
};

OrderEmailContent.propTypes = {
  router: PropTypes.shape({}).isRequired,
};

export default withRouter(OrderEmailContent);
